import { useEffect, useState, useRef } from 'react';
import libDebounce from 'lodash.debounce';
const useHasBeenSeen = (options) => {
    const [hasBeenSeen, setHasBeenSeen] = useState(false);
    const [node, setNode] = useState(null);
    const observer = useRef(null);
    // Enabling debouncing ensures the target element intersects for at least
    // 200ms before the callback is executed
    const intersectionFn = ([entry]) => {
        if (entry.isIntersecting) {
            setHasBeenSeen(true);
        }
    };
    const intersectionCallback = options.debounce
        ? libDebounce(intersectionFn, 200)
        : intersectionFn;
    useEffect(() => {
        if (observer.current) {
            observer.current.disconnect();
        }
        observer.current = new window.IntersectionObserver(intersectionCallback, options);
        const { current: currentObserver } = observer;
        if (node) {
            currentObserver.observe(node);
        }
        return () => currentObserver.disconnect();
    }, [node, options, intersectionCallback]);
    return [hasBeenSeen, setNode];
};
export { useHasBeenSeen };
